import { render, staticRenderFns } from "./QyrgDetail.vue?vue&type=template&id=0631d6ee&scoped=true&"
import script from "./QyrgDetail.vue?vue&type=script&lang=js&"
export * from "./QyrgDetail.vue?vue&type=script&lang=js&"
import style0 from "./QyrgDetail.vue?vue&type=style&index=0&id=0631d6ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0631d6ee",
  null
  
)

export default component.exports